var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-action-sheet',{attrs:{"actions":_vm.columns,"cancel-text":"取消","round":false,"title":_vm.title,"close-on-click-overlay":false},on:{"select":_vm.onConfirm,"cancel":_vm.onCancel},model:{value:(_vm.popupVisible),callback:function ($$v) {_vm.popupVisible=$$v},expression:"popupVisible"}})
}
var staticRenderFns = []

export { render, staticRenderFns }